export default class UnloadRecommendedAnswers {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.recommendedAnswers.set([]);

    const appFeatures = this.context.stores.appFeatures.get();
    if (appFeatures.isEnabled('viewAnswerPerformance') || appFeatures.isEnabled('answers:admin')) {
      this.context.gateways.recommendedAnswers.unsubscribeAll();
    }
  }
}
